import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from 'dibs-vg/dist/react/close';
import RemoveModal from './CartRemoveModal';

import styles from './styles/CartRemoveItemLink.scss';

function CartRemoveItemLink({ onRemoveItem }) {
    const [showModal, setShowModal] = useState(false);
    return (
        <div
            className={styles.container}
            data-tn="cart-remove-link"
            onClick={() => setShowModal(true)}
        >
            <CloseIcon />
            <RemoveModal
                showModal={showModal}
                onClose={() => setShowModal(false)}
                onClick={() => {
                    onRemoveItem();
                    setShowModal(false);
                }}
            />
        </div>
    );
}

CartRemoveItemLink.propTypes = {
    onRemoveItem: PropTypes.func.isRequired,
};

export default CartRemoveItemLink;
